import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Image } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';

const styles = css`
.OSCTag {
  display: none;
  height: 69px;
  background-color: ${colors.color2};
  @media (min-width: 992px) {
    display: block;
    position: absolute;
    background-color: ${colors.color3};
    right: 0;
    top: 115px;
    cursor: pointer;
    &:hover {
      background-color: ${colors.color1Lightest};
    }
  }
}
.OSCTag_image {
  float: left;
  position: relative;
  overflow: hidden;
  width: 88px;
  height: 100%;
  img {
    position: absolute;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
    margin: auto;
    min-width: 100%;
    min-height: 100%;
  }
  @supports (object-fit: cover) and (object-position: center center) {
    position: static;
    img {
      position: static;
      width: 100%;
      height: 100%;
      margin: 0;
      min-width: 0;
      min-height: 0;
      object-fit: cover;
      object-position: center center;
    }
  }
}
.OSCTag_content {
  float: left;
  width: 152px;
}
.OSCTag_headline {
  padding: 0 25px 0 15px;
  height: 47px;
  background-color: ${colors.color2};
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  span {
    font-family: ${typography.Serif};
    font-size: 20px;
    line-height: 27px;
  }
}
.OSCTag_phone {
  font-size: 13px;
  font-weight: 900;
  height: 22px;
  color: ${colors.color1};
  padding: 0 20px 0 15px;
  line-height: 22px;
  background-color: rgba(255,255,255,1);
  letter-spacing: 1px;
  span {
    color: ${colors.color5};
  }
}
.OSCMobileTag {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 60px;
  width: 100%;
  background-color: ${colors.color2};
  @media (min-width: 992px) {
    display: none;
  }
}
.OSCMobileTag_image {
  float: left;
  width: 40%;
  height: 60px;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    max-width: 110px;
  }
}
.OSCMobileTag_content {
  float: left;
  width: 100%;
}
.OSCMobileTag_headline {
  float: left;
  height: 60px;
  background-color: ${colors.color1};
  font-size: 15px;
  line-height: 17px;
  font-weight: 900;
  color: white;
  text-transform: uppercase;
  width: 50%;
  span {
    display: inline-block;
    padding: 12px 10px;
  }
  @media (max-width: 340px) {
    span {
      font-size: 12px;
    }
  }
}
.OSCMobileTag_links {
  float: left;
  font-size: 11px;
  font-weight: 900;
  height: 60px;
  width: 50%;
  color: white;
  line-height: 22px;
  background-color: ${colors.color2};
  list-style: none;
  padding: 0;
  vertical-align: top;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
  li {
    display: inline-block;
    text-align: center;
    a, span {
      color: #FFFFFF;
    }
  }
  span {
    color: ${colors.color5};
  }
}
`;

function OSCTag({ builder, agent }) {
  const OSCNumber = get(agent, 'telephone') ? get(agent, 'telephone') : get(builder, 'telephone');
  const agentPhotoUrl = get(agent, 'logo.contentUrl');
  return (
    <div className={styles}>
      <div className="OSCTag">
        {
          agentPhotoUrl &&
          <div className="OSCTag_image">
            <Image
              src={agentPhotoUrl}
              alt={`${get(agent, 'name')} - ${get(agent, 'title')}`}
              width={120}
              height={120}
            />
          </div>
        }
        <div className="OSCTag_content">
          <div className="OSCTag_headline">
            <span>Questions?</span><br />Click or call today!
          </div>
          <div className="OSCTag_phone">
            <span>{OSCNumber}</span>
          </div>
        </div>
      </div>
      <div className="OSCMobileTag">
        <div className="OSCMobileTag_content">
          <div className="OSCMobileTag_headline">
            {
              agentPhotoUrl &&
              <div className="OSCMobileTag_image">
                <Image
                  src={agentPhotoUrl}
                  alt={`${get(agent, 'name')} - ${get(agent, 'title')}`}
                  width={120}
                  height={120}
                />
              </div>
            }
            <span>Have<br />Questions?</span>
          </div>
          <ul className="OSCMobileTag_links">
            <li>
              <a href={`tel:${OSCNumber.replace(/[^0-9]/g, '')}`}>
                <img src="/images/icon-phone-white.svg" alt="telephone" /><br />Call
              </a>
            </li>
            <li><img src="/images/icon-email-white.svg" alt="envelope" /><br />Email</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

OSCTag.propTypes = {
  builder: PropTypes.object.isRequired,
  agent: PropTypes.object,
};

OSCTag.defaultProps = {
  agent: undefined,
};

export default withData(
  {
    builder: true,
  },
  {
    required: {
      builder: true,
    },
  },
)(OSCTag);



// WEBPACK FOOTER //
// ./src/components/OSCTag.js